import React from 'react';
import './List.css';
import { FaDiamond } from "react-icons/fa6";

const PageList = ({ items }) => (
    <ul className='page-list'>
        {items.map((item, index) => (
            <PageListItem
                key={index}
                title={item.title}
                paragraph={item.paragraph}
                Icon={item.icon}
            />
        ))}
    </ul>
);

export default PageList;

const PageListItem = ({ title, paragraph, Icon = FaDiamond }) => (
    <li className='page-list-item'>
        <div className='page-list-icon-box'>
            {Icon && <Icon className='list-diamon-icon' />}
        </div>

        {title && <span className='page-list-title'>{title}</span>}

        {/* 👇 Allow HTML inside paragraph */}
        <p
            className='page-list-paragraph'
            dangerouslySetInnerHTML={{ __html: paragraph }}
        ></p>
    </li>
);
